import React from "react";
import Breadcrumb from "./Breadcrumb";
import ToolBar from "./ToolBar";
import { useLocation, matchPath } from "react-router-dom";
import routes from "../../../config/routes/routes";
import classNames from "classnames";

import styles from "./SubHeader.module.scss";

const SubHeader = () => {
    const location = useLocation();

    const route = Object.values(routes).find(r => {
        if (
            !r.route ||
            typeof r.route !== "string" ||
            r.route.startsWith("http")
        ) {
            return false;
        }
        return matchPath(location.pathname, {
            path: r.route,
            exact: true,
        });
    });

    return (
        <div
            className={classNames(styles.root, {
                [styles.isDashboard]: route?.root && !route?.guide,
                [styles.isGuide]: route?.guide,
            })}
        >
            <Breadcrumb route={route} />
            <ToolBar route={route} />
        </div>
    );
};

export default SubHeader;
